/* eslint-disable func-style */
import React from "react";
import { Tabs as TabsMUI, Tab, Badge, withStyles } from "@material-ui/core";
import { TabContext } from "@material-ui/lab";

interface TabContext<T> {
  value:T;
  label:React.ReactNode;
  badgeContents?: React.ReactNode;
}

export interface TabProps<T> {
  value:T;
  setValue: (value:T) => void;
  tabs:TabContext<T>[];
}

const StyledBadge = withStyles((theme) => ({
  badge: {
    top: 11,
    right: -16,
    padding: "0 4px",
    margin: 0,
    fontSize: 12,
    color: "white",
    backgroundColor: theme.palette.primary.main,
  },
}))(Badge);

const StyledTab = withStyles((theme) => ({
  root: {
    textTransform: "none",
    color: "black",
    fontWeight: 600,
    fontSize: "90%",
    minWidth: 0,
  },
  selected: { color: theme.palette.primary.main },
  wrapper: {},
}))(Tab);

const StyledBadgeTab = withStyles(() => ({
  root: {
    paddingRight: 55,
  },
  wrapper: { marginRight: -24 },
}))(StyledTab);

const StyledTabs = withStyles(() => ({
  root: {
    borderBottom: "1px solid grey",
  },
}))(TabsMUI);

export default function Tabs<T extends React.Key> (
  { value, setValue, tabs }: Readonly<TabProps<T>>,
) {
  return <StyledTabs value={value}
    indicatorColor="primary"
    variant="scrollable"
    scrollButtons="auto"
    onChange={(_event, val) => setValue(val)}>
    {tabs.map(tab => (tab.badgeContents ? <StyledBadgeTab
      key={tab.value}
      label={<StyledBadge variant="standard" color="primary" badgeContent={tab.badgeContents} showZero>{tab.label}</StyledBadge>}
      value={tab.value}
    /> : <StyledTab key={tab.value} label={tab.label} value={tab.value} />
    ))}
  </StyledTabs>;
}
